import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the auth state interface
export interface AuthState {
    token: string | null;
    role: string | null;
    loading: boolean;
    error: string | null;
}

// Initial state
const initialState: AuthState = {
    token: localStorage.getItem('token'),
    role: localStorage.getItem('role'),
    loading: false,
    error: null,
};

// Create the auth slice
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            console.log('Setting token in Redux state:', action.payload);
            state.token = action.payload;
            localStorage.setItem('token', action.payload);
        },
        setRole: (state, action: PayloadAction<string>) => {
            state.role = action.payload;
            localStorage.setItem('role', action.payload);
        },
        logout: (state) => {
            state.token = null;
            state.role = null;
            localStorage.removeItem('token');
            localStorage.removeItem('role');
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

// Export actions
export const { setToken, setRole, logout, setLoading, setError } = authSlice.actions;

// Export reducer
export default authSlice.reducer; 